import React, { memo } from 'react';
import { connect } from 'react-redux';

import { __WEB__ } from '../../constants/styles';
import { getEditingCase, getEditingCaseEmployer } from './selector';
import { getCurrentEmployer } from '../../selectors/entities';

import CaseFormEmployer from './case_form_employer';
import CaseFormConsumer from './case_form_consumer';

const CaseForm = memo((props) => {
  if (
    (props.editingCase && props.editingCaseEmployer) ||
    (!props.editingCase && props.currentEmployer)
  ) {
    return <CaseFormEmployer {...props} />;
  } else {
    return <CaseFormConsumer {...props} />;
  }
});

function mapStateToProps(state, ownProps) {
  return {
    editingCase: getEditingCase(state),
    editingCaseEmployer: getEditingCaseEmployer(state),
    currentEmployer: getCurrentEmployer(state),
  };
}

export default connect(mapStateToProps, null)(CaseForm);
